export default {"src":"/_next/static/media/0x82f0b8b456c1a451378467398982d4834b6829c1.652cee79.svg","height":108,"width":108,"blurWidth":0,"blurHeight":0};